import styled, { css } from "styled-components";
import { SubheadLgStyle } from "../../Typography";

import theme from "../../../styles/theme";

const TopLinkStyle = css`
  ${SubheadLgStyle};
  background: transparent;
  font-size: 2rem;
  width: 100%;
  position: relative;
  text-align: left;
  border: none;
  color: ${props =>
    props.open ? theme.colors.black : theme.colors.black};
  text-decoration: none;
  font-weight: 500;
  padding: 0 12px 8px;
  margin-bottom: 50px;
  border-bottom: ${() => theme.colors.green3} 2px solid;
`;

const StyledLink = styled.a`
  ${TopLinkStyle}
`;
const StyledButton = styled.button`
  ${TopLinkStyle}
`;

export { StyledLink, StyledButton, TopLinkStyle };
